// Name of the localStorage item
const AUTH_SESSION_ID = 'session-id'

export const getAuth = () => {
  const token = window.localStorage[AUTH_SESSION_ID]
  return token ? 'Bearer '.concat(token) : ''
}
